import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { DriverModel } from './../../driver/models/driver.model';
import { Component, OnInit, ViewChild, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel } from '../../shared/config';
import { InvoiceService } from '../models/invoice.service';
import { OrganizationModel } from '../../organization/models/organization.model';


@Component({
  selector: 'wego-invoice-organization-popup',
  template: require('../views/invoice-organization-popup.component.html'),
  providers: [InvoiceService]
})

export class InvoiceOrganizationPopupComponent implements OnInit, OnChanges {
  DataListModel: DataListModel;
  organizationList: OrganizationModel[];
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;
  instanceHashId: string;
  companyHashId: string;

  @Output('OnSuccessSelect') onSuccessSelect = new EventEmitter();
  @ViewChild('driverModal') public driverModal: any;

  constructor(private authService: AuthService
    , private router: Router
    , private translate: TranslateService
    , private invoiceService: InvoiceService) { }

  ngOnInit() {
    this.DataListModel = new DataListModel();
    this.DataListModel.searchField = ["organizationName", "companyName", "instanceName"];
  }

  ngOnChanges(change: any) {
    console.log(change);
  }

  public show(instanceHashId: string, companyHashId: string): void {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.sortType = "";
    this.DataListModel.sortReverse = null;
    this.DataListModel.searchTerm = "";
    this.DataListModel.infoMessage = "";
    this.instanceHashId = instanceHashId;
    this.companyHashId = companyHashId;
    this.GetOrganizationList();
    this.driverModal.show();
  }

  public hide(): void {
    this.driverModal.hide();
  }

  private GetOrganizationList() {
    this.isLoading = true;
    this.invoiceService.GetOrganizationList(this.instanceHashId, this.DataListModel, this.companyHashId)
      .subscribe(
        res => {
          this.organizationList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
  }

  private select(organization: OrganizationModel): void {
    this.isLoading = true;
    this.onSuccessSelect.emit({ OrganizationHashID: organization.organizationMasterHashId, OrganizationName: organization.organizationName });
    this.isLoading = false;
    this.hide();
  }

  private OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetOrganizationList();
  }

  private OnSearch(event: any) {
    this.DataListModel.searchTerm = event.searchTerm;
    this.DataListModel.currentPage = 1;
    this.GetOrganizationList();
  }

  private OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetOrganizationList();
  };

  public OnPagingChange(event: any) {
    console.log(this.DataListModel);
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetOrganizationList();
  }
  private OnSuccessSelect() {
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/invoice/components/invoice-organization-popup.component.ts